import Api from "../../../util/Api";

export default function getInitState() {
    return {
        doctorConsultConfigIsShow: true,
        doctorConsultTableIsShow: true,
        doctorConsultFormIsShow: false,

        doctorHolidayIsShow: false,
        doctorHolidayTableIsShow: true,
        doctorHolidayFormIsShow: false,

        doctorConsultDataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        doctorConsultActions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Új rendelés',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newConsulting'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Orvos szerinti szabadság',
                event_name: "customClick",
                class: "btn btn-info my-custom-class",
                event_payload: 'showHoliday'
            }
        ],
        doctorConsultFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToDoctorConsultGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetDoctorConsultForm'
            },
            {
                btn_text: '<i class="fa fa-check"></i> Ellenőrzés',
                event_name: "customClick",
                class: "btn btn-info my-custom-class mx-1",
                event_payload: 'checkDates'
            }
        ],
        doctorConsultRowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyDoctorConsultRow'
            }, {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteDoctorConsultRow'
            }
        ],
        doctorConsultSearchFields: [
            {
                name: "doctorId",
                label: "Orvos",
                visibility: false,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getAllDoctor,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 4
            },
            {
                name: "siteId",
                label: "Ellátóhely",
                visibility: false,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getCompanySitesByCompanyId,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'keresés',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 4
            },
            {
                name: "roomId",
                label: "Szoba",
                visibility: false,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getAllRoomByType1182,
                    additionalApiCallbackParams: {
                        type: 1182
                    },
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 4
            },
            {
                name: "dateFrom",
                label: "Dátumtól",
                formSize: 4,
                formType: 'date'
            },
            {
                name: "dateTo",
                label: "Dátumig",
                formSize: 4,
                formType: 'date'
            },
        ],
        doctorHolidayActions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új szabadság',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newHoliday'
            },
        ],
        doctorHolidayFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToDoctorHolidayGrid'
            }, {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetDoctorHolidayForm'
            }
        ],
        doctorHolidayRowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyDoctorHolidayRow'
            }, {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteDoctorHolidayRow'
            }
        ],
        doctorHolidayHeaderFields: [
            {
                name: "id",
                label: "id",
                visibility: false,
                formVisible: false
            },
            {
                name: "companyId",
                label: "companyId",
                visibility: false,
                formVisible: false
            },
            {
                name: "companySiteId",
                label: "Ellátóhely",
                description: "Amennyiben nincs kiválasztva ellátóhely, minden ellátóhelyre vonatkozik a szabadság.",
                visibility: false,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getCompanySitesByCompanyId,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 4,
                formVisible: true
            },
            {
                name: "companySite.siteName",
                label: "Ellátóhely",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
            },
            {
                name: "doctor",
                label: "Orvos",
                visibility: false,
                formVisible: false
            },
            {
                name: "doctorId",
                label: "Orvos azonosító",
                visibility: false,
                formVisible: false
            },
            {
                name: 'startDate',
                label: 'Dátum',
                slot_name: 'holidayDateFromTo_format',
                visibility: true,
                formVisible: false
            },
            {
                name: "startDate",
                label: "Időponttól",
                visibility: false,
                formType: "date",
                formSize: 4,
                formRequired: true,
                formVisible: true
            },
            {
                name: "endDate",
                label: "Időpontig",
                visibility: false,
                formType: "date",
                formSize: 4,
                formRequired: true,
                formVisible: true
            },
            {
                name: "createdBy",
                label: "createdBy",
                visibility: false,
                formVisible: false
            },
            {
                name: "createdOn",
                label: "createdOn",
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                visibility: false,
                formVisible: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],
    }
}
